// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jZcVez_ko4AIERNK {
  flex-shrink: 0;
  padding: 0;
}

.t4tOe1kljkGOD97Z {
  height: var(--lp-size-24);
  width: var(--lp-size-24);
}

.wW4AjypcJcVIVK6J {
  height: var(--lp-size-32);
  width: var(--lp-size-32);
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/IconButton.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":[".base {\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.small {\n  height: var(--lp-size-24);\n  width: var(--lp-size-24);\n}\n\n.medium {\n  height: var(--lp-size-32);\n  width: var(--lp-size-32);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `jZcVez_ko4AIERNK`,
	"small": `t4tOe1kljkGOD97Z`,
	"medium": `wW4AjypcJcVIVK6J`
};
export default ___CSS_LOADER_EXPORT___;
